<template>
  <basic-dialog :maxWidth="maxWidth" :show="show" @close="$emit('close')">
    <template v-slot:title>{{ title }}</template>

    <v-row>
      <v-col>
        <pickup-point-list-select
          v-model="pickupPoint"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          v-model="pickupTime"
          label="Pickup Time"
          type="time"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <pickup-point-list-select
          v-model="dropoffPoint"
          label="Drop-off Point"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          v-model="dropoffTime"
          label="Drop-off Time"
          type="time"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          v-model="address"
          label="Address"
          :outlined="outlinedInputs"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Coordinates (lat, lon)"
          v-model="coordinates"
          :outlined="outlinedInputs"
          append-icon="mdi-map-marker"
          @click:append="onCoordinatesClick"
        ></v-text-field>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave">Save</v-btn>
    </template>
    <coordinates-dialog
      :show="showCoordinatesMap"
      @close="showCoordinatesMap = false"
      @save="showCoordinatesMap = false"
      :address="address"
      v-model="coordinates"
    ></coordinates-dialog>
    <v-row v-if="debug">
      <v-col cols="12">
        <pre>{{ value }}</pre>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import CoordinatesDialog from "../../shared/CoordinatesDialog.vue";
import PickupPointListSelect from "../../shared/PickupPointListSelect.vue";
export default {
  components: { BasicDialog, PickupPointListSelect, CoordinatesDialog },
  name: "service-remarks-dialog",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    maxWidth: {
      type: String,
      default: () => "800",
    },
  },

  data() {
    return {
      debug: false,
      pickupPoint: this.value ? this.value.pickupPoint : "",
      dropoffPoint: this.value ? this.value.dropoffPoint : "",
      pickupTime: this.value ? this.value.pickupTime : "",
      dropoffTime: this.value ? this.value.dropoffTime : "",
      address: this.value && this.value.address ? this.value.address : "",
      coordinates: this.value ? this.value.coordinates : "",
      showCoordinatesMap: false,
    };
  },

  computed: {
    title() {
      return this.value ? `${this.value.name} - Remarks` : "Service Remarks";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newValue) {
      this.pickupPoint = newValue ? newValue.pickupPoint : "";
      this.dropoffPoint = newValue ? newValue.dropoffPoint : "";
      this.pickupTime = newValue ? newValue.pickupTime : "";
      this.dropoffTime = newValue ? newValue.dropoffTime : "";
      this.address = newValue && newValue.address ? newValue.address : "";
      this.coordinates = newValue ? newValue.coordinates : "";
    },
  },

  methods: {
    onSave() {
      console.log("onSave");
      this.$emit("save", {
        pickupPoint: this.pickupPoint,
        dropoffPoint: this.dropoffPoint,
        pickupTime: this.pickupTime,
        dropoffTime: this.dropoffTime,
        address: this.address,
        coordinates: this.coordinates,
      });
    },
    onCoordinatesClick() {
      this.showCoordinatesMap = true;
    },
  },
};
</script>

<style></style>
</style>


// WEBPACK FOOTER //
// src/components/gt/suppliers/services/ServiceRemarksDialog.vue